<script lang="ts">
  import Cone from './assets/cone.webp';
  import HalfCircle from './assets/half-circle.webp';
</script>

<div class="pointer-events-none absolute -left-[130px] bottom-[140px] hidden w-[230px] xl:block">
  <img role="presentation" src={Cone} alt="" />
</div>

<div class="pointer-events-none absolute -right-[220px] top-[280px] hidden w-[350px] xl:block">
  <img role="presentation" src={HalfCircle} alt="" />
</div>
